import { useEffect } from "react";
import { useGenericActivityFromElysiumMutation } from "src/api/client/generic-activity-from-elysium.api";
import { EnumActivityType } from "src/api/client/generic-activity.api";
import { isServerSide } from "src/utils/common-util";

interface IUseContentPageVisitTrackingProps {
    activityType?: EnumActivityType;
    includeHash?: boolean;
    identifierOnly?: boolean;
}

export const useContentPageVisitTracking = ({
    activityType = EnumActivityType.ContentPageVisit,
    includeHash = false,
    identifierOnly = false,
}: IUseContentPageVisitTrackingProps = {}) => {
    const genericActivity = useGenericActivityFromElysiumMutation();

    useEffect(() => {
        if (isServerSide()) {
            return;
        }

        const { pathname, search, hash } = globalThis.document.location;

        const pathSegments = pathname.split("/").filter(Boolean);
        const lastPathSegment = pathSegments[pathSegments.length - 1] || pathname;

        const baseParameter = identifierOnly ? lastPathSegment : pathname + search;
        const parameter = includeHash && hash ? `${baseParameter}${hash}` : baseParameter;

        genericActivity({
            activityTypeId: activityType,
            parameter,
            referrer: globalThis.document.referrer || null,
        });
    }, [activityType, genericActivity, includeHash, identifierOnly]);
};
